export var minAmount = {
    RUR: 5,
    TJS: 0.5,
    KZT: 15,
    USD: 0.01,
    EUR: 0.01,
    GBP: 0.01,
    KSH: 5,
    PEN: 0.01,
    UZS: 1000,
};



// WEBPACK FOOTER //
// ./src/constants/StakeMinAmount.js